module.exports = __webpack_public_path__ + "media/images/signatures/edgar_derek-51b2cbb8380edecd54e4e4ed48bffeed.png";